import { render } from "./OurClients.vue?vue&type=template&id=4deb52de"
import script from "./OurClients.vue?vue&type=script&lang=js"
export * from "./OurClients.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__